import React from 'react';
import PropTypes from 'prop-types';

import Response from './Response';

// Presentational Component
const ObjectType = ({ response, history }) => {
	return (
		<div className="route-item">
			<h3 className="path">{response.name}</h3>

			{response.summary &&
				<p>{response.summary}</p>
			}

			{response.notes &&
				<p className="notes">Notes: {response.notes}</p>
			}

			<Response response={response} />

			<a className="button" onClick={history.goBack}>Go Back</a>
		</div>
	);
};

ObjectType.propTypes = {
	response: PropTypes.object.isRequired,
	history: PropTypes.object.isRequired
};

export default ObjectType;


// WEBPACK FOOTER //
// ./src/components/api/ObjectType.js